
import dust from "dustjs-linkedin";


(function(){dust.register("tooltip",body_0);function body_0(chk,ctx){return chk.write("<div class=\"tooltip\">").reference(ctx.get(["text"], false),ctx,"h").write("</div>");}return body_0;})();

export default 0;
